import {ModelContext} from '../../../types/app.types';
import {shorten} from '../../utils/shorten';
import {SPECS} from '../../specs';
import {cartV2} from '@wix/ecom';

export class DiscountModel {
  public name: string;
  public scope: DiscountScope;
  public sourceType: DiscountSource;
  public totalAmountOff: string;
  public targetLineItemIds: string[];

  constructor(params: DiscountModel) {
    this.name = params.name;
    this.scope = params.scope;
    this.totalAmountOff = params.totalAmountOff;
    this.targetLineItemIds = params.targetLineItemIds;
    this.sourceType = params.sourceType;
  }

  public static fromCartV2(discount: cartV2.Discount, modelContext: ModelContext) {
    const isCoupon = discount.source?.sourceType === cartV2.DiscountSourceType.COUPON;
    const discountName = discount.source?.couponCode ?? discount.name.translated ?? discount.name.original;
    return new DiscountModel({
      name: modelContext.viewerContext.isExperimentEnabled(SPECS.RevampDiscountsInCartAndCheckout)
        ? shorten(isCoupon ? discountName.toUpperCase() : discountName, 23, '...')
        : discountName,
      scope: toCouponDiscountScope(discount.scope),
      totalAmountOff: modelContext.formatAmount(discount.total?.convertedAmount),
      targetLineItemIds: discount.lineItemDiscounts?.map((lid) => lid.lineItemId) ?? [],
      sourceType: toDiscountSource(discount.source?.sourceType),
    });
  }
}

export enum DiscountScope {
  CART_SUBTOTAL = 'CART_SUBTOTAL',
  LINE_ITEM = 'LINE_ITEM',
  DELIVERY = 'DELIVERY',
}

export enum DiscountSource {
  COUPON = 'COUPON',
  AUTOMATIC_RULE = 'AUTOMATIC_RULE',
  UNKNOWN_DISCOUNT_SOURCE_TYPE = 'UNKNOWN_DISCOUNT_SOURCE_TYPE',
}

const toDiscountSource = (discountSource: cartV2.DiscountSourceTypeWithLiterals) => {
  switch (discountSource) {
    case cartV2.DiscountSourceType.COUPON:
      return DiscountSource.COUPON;
    case cartV2.DiscountSourceType.AUTOMATIC_RULE:
      return DiscountSource.AUTOMATIC_RULE;
  }
};

const toCouponDiscountScope = (discountScope: cartV2.DiscountScopeWithLiterals) => {
  switch (discountScope) {
    case cartV2.DiscountScope.DELIVERY:
      return DiscountScope.DELIVERY;
    case cartV2.DiscountScope.LINE_ITEM:
      return DiscountScope.LINE_ITEM;
    case cartV2.DiscountScope.CART_SUBTOTAL:
    case cartV2.DiscountScope.UNKNOWN_DISCOUNT_SCOPE:
      return DiscountScope.CART_SUBTOTAL;
  }
};
